import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DynamicFormService {

    private isFormSubmittedSubject: Subject<boolean> = new Subject<boolean>();
    private valueChangeSubject: Subject<any> = new Subject<any>();
    private openPanelSubject: Subject<string> = new Subject<string>();

    constructor() {
    }

    public onFormSubmitted(isSubmitted: boolean) {
        this.isFormSubmittedSubject.next(isSubmitted);
    }

    public getFormSubmittedEvent(): Observable<boolean> {
        return this.isFormSubmittedSubject.asObservable();
    }

    public getValueChangeEvent(): Observable<any> {
        return this.valueChangeSubject.asObservable();
    }

    public onValueChange(data: any) {
        this.valueChangeSubject.next(data);
    }

    public getOpenPanelEvent(): Observable<string> {
      return this.openPanelSubject.asObservable();
    }

    public onOpenPanel(key: string) {
        this.openPanelSubject.next(key);
    }

    getField(key: string, fields: FormlyFieldConfig[]): FormlyFieldConfig {
        for (let i = 0, len = fields.length; i < len; i++) {
            const f = fields[i];
            if (f.key === key) {
                return f;
            }

            if (f.fieldGroup && !f.key) {
                const cf = this.getField(key, f.fieldGroup);
                if (cf) {
                    return cf;
                }
            }
        }
    }

}
